export const EDIT = "保存する";
export const ADD = "追加する";
export const EDITING = "編集";
